import type { AppBarTheme } from "~/components/app-bar/helpers";
import { PageType } from "~/lib/router/enums";

export const pathname = "/article";

export const page = {
  route(
    query: QueryParameters<{
      appBarTheme?: AppBarTheme;
      commentID?: string;
      entityId: string;
      entityUuid: string;
    }>,
  ) {
    return {
      pathname,
      query: { ...query, pageType: PageType.Article },
    };
  },
};
